export default class WindowUtil{
    static isMobile(){
        return window.innerWidth <= 768
    }
}